import { Text } from '@vkontakte/vkui';
import formatFns from 'date-fns/format';
import ruLocale from 'date-fns/locale/ru';
import freemiumIsEndingImage from 'img/freemium/freemiumIsEnding.png';
import freemiumIsEndingImageDark from 'img/freemium/freemiumIsEndingDark.png';
import React from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { closeCommonWhatsNewDialog, renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FreemiumEndingModal.css';

const DISCOUNT_TARIFF_ID = 'W256GB_1m_family_features_discount_3m';

interface FreemiumEndingModalProps {
    expiresDate: number;
}

const getAnalyticsName = (): string => {
    if (isHardFreemium) {
        return 'mnz_sub_end_soon_unlimited_hard_freemium';
    }
    if (isSoftFreemium) {
        return 'mnz_sub_end_soon_unlimited_soft_freemium';
    }
    return 'mnz_sub_end_soon_unlimited_soft_freemium';
};

const getPaySource = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_unlimited_hard_freemium_modal_sub_end_soon';
    }
    if (isSoftFreemium) {
        return 'mnz_family_unlimited_soft_freemium_modal_sub_end_soon';
    }
    return 'mnz_family_unlimited_soft_freemium_modal_sub_end_soon';
};

export const renderFreemiumEndingModal = ({ expiresDate }: FreemiumEndingModalProps): void => {
    const formattedDate = formatFns(expiresDate, 'd.MM', { locale: ruLocale });
    const analyticsName = getAnalyticsName();
    const paySource = getPaySource();

    sendDwh({
        eventCategory: 'modal',
        action: 'show',
        dwhData: {
            name: analyticsName,
        },
        dwh_enabled: true,
    });

    const handleClick = async () => {
        closeCommonWhatsNewDialog();
        sendDwh({
            eventCategory: 'modal',
            action: 'click',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
        await productsController.loadProducts();
        reduxStore.dispatch(
            openTariffBuy({
                productId: DISCOUNT_TARIFF_ID,
                paySource,
                title: 'Семейный тариф Mail Space',
            })
        );
    };

    const handleClose = () => {
        sendDwh({
            eventCategory: 'modal',
            action: 'close',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
    };

    const imageAdditionalContent = (
        <div className={styles.imageText}>
            <div className={styles.imageTitle}>
                256<span className={styles.imageTitleSmall}> ГБ</span>
            </div>
            <div className={styles.imageSubtitle}>Пробная подписка до {formattedDate}</div>
        </div>
    );

    const content = (
        <div className={styles.items}>
            <Text className={styles.text}>
                Продлите её, чтобы сохранить безлимит и другие возможности подписки. Без продления фото с телефона могут выйти за лимит
                базовых 8 ГБ.
                <br />
                Если это случится, в Почте и Облаке появятся ограничения
            </Text>
        </div>
    );

    renderCommonWhatsNewDialog({
        title: 'У вас заканчивается действие пробной подписки',
        titleClassName: styles.modalTitle,
        content,
        primaryButtonText: 'Продлить со скидкой',
        primaryButtonClassName: styles.primaryButton,
        imageUrl: isDarkTheme ? freemiumIsEndingImageDark : freemiumIsEndingImage,
        imageWrapperClassName: styles.imageWrapper,
        imageAdditionalContent,
        closable: true,
        closeOnEscape: true,
        closeOnDimmerClick: true,
        onClick: handleClick,
        onClose: handleClose,
    });
};
